import { useSelector } from "react-redux";
import { RootState } from "../../store/types";
import { useState } from "react";
import { useGetMeQuery } from "../../services/me";
import { Button, Divider } from "antd";
import Icon from "../../components/Icon";
import HrnAvatar from "../../components/HrnAvatar";
import { useNavigate } from "react-router-dom";
import ROUTES from "../../routes";
import { useTranslation } from "react-i18next";


const UserSettings = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { loggedInUser } = useSelector((state: RootState) => state.global);
  const [profileSections, setProfileSections] = useState<any[]>(
    [
      {
        title: "Profile information",
        section: "basic"
      },
      {
        title: "Change password",
        section: "password"
      }
    ]);

  const {
    data: userProfile,
    isSuccess: isUserProfileSuccess,
    isFetching: isUserProfileFetching,
  } = useGetMeQuery({});

  const onSectionClick = (event: any, sec: any) => {
    navigate(`${ROUTES.PATHS.PROFILE}/${sec.section}`)
  };

  return (
    <div className="pt-2">
      {loggedInUser &&
        isUserProfileSuccess &&
        userProfile && (
          <>
            <div className="profile">
              <div className="mb-4" style={{ padding: "5px calc(50% - 60px)" }}>
                <div className="w-[120px]" style={{ position: "relative" }} >
                  <HrnAvatar size={120} photo={userProfile.photograph} />
                  <Button type="link"  style={{ width: "2rem", position: "absolute", bottom: "0px", right: "10px" }}>
                    <Icon icon="photo_camera" className="h-8 w-8" />
                  </Button>
                </div>
              </div>

            </div>
            <Divider className="mt-1 mb-1" style={{ borderColor: "#ccc" }} />
            <div>
              {
                profileSections.map((x, index) => (
                  <Button onClick={(event) => onSectionClick(event, x)} key={index} className="b1 text-left w-[100%] h-[40px] mt-1" style={{ borderTop: "none" }}>
                    <div className="w-[100%]">
                      <span className="float-let" >{t(x.title)}</span>
                      <Icon icon="chevron_right" className="h-5 w-5 float-right" />
                    </div>
                  </Button>
                ))
              }
            </div>
          </>
        )
      }
    </div >
  );
};

export default UserSettings;
